export default __webpack_public_path__ + "static/media/IMG_20190813_202750_686.a1ad895b.jpg";